import { PricingModulesStatus } from '../../context/contexts/PricingModuleContext';
import { LOGS_FILTER_OBJECTS_BY_PRICING_MODULES, LOGS_FILTER_VALUES_BY_PRICING_MODULES } from './consts';

export const getFiltersByPricingModules = (filters: object, pricingModulesState: PricingModulesStatus): object => {
    return Object.entries(filters).reduce((filtersToDisplay, [filterKey, filterObject]) => {
        const shouldDisplayFilter = LOGS_FILTER_OBJECTS_BY_PRICING_MODULES[filterKey]?.(pricingModulesState) ?? true;

        if (shouldDisplayFilter) {
            const { filterConfig } = filterObject;

            const options = filterConfig?.options?.filter(
                (option) =>
                    LOGS_FILTER_VALUES_BY_PRICING_MODULES[filterKey]?.[option.value]?.(pricingModulesState) ?? true
            );

            return {
                ...filtersToDisplay,
                [filterKey]: { ...filterObject, filterConfig: filterConfig ? { ...filterConfig, options } : undefined }
            };
        }

        return filtersToDisplay;
    }, {});
};
